import centrifuge from "@/services/centrifugo_base.service"
import { client } from "@/services/apollo.service"
import ACTIVE_SESSIONS_QUERY from "@/graphql/active_sessions.gql"
import { emitAlert } from "@/helpers/alert.helper"
import { EVENTS } from "@/constants"
import { Commit } from "vuex"
import { RootState } from "@/store"
import { ActiveSessionsState } from "./active-sessions"

function activeSessionsChannel(orgId: string | undefined): string {
  return orgId ? `cat:active_sessions_${orgId}` : "cat:active_sessions"
}

export default {
  async connect({
    commit,
    state,
    rootState,
    dispatch,
  }: {
    commit: Commit
    state: ActiveSessionsState
    rootState: RootState
    dispatch: any
  }) {
    if (state.connection) return

    let currentUser = rootState.currentUser?.currentUser as any
    if (!currentUser?.catOrganizationId) {
      await dispatch("currentUser/load", null, { root: true })
      currentUser = rootState.currentUser?.currentUser as any
    }

    const orgId = currentUser?.catOrganizationId
    const channel = activeSessionsChannel(orgId)
    const connection = centrifuge.subscribe(channel, message => {
      commit("replaceSessions", message.data)
    })
    commit("setConnection", connection)
  },

  disconnect({ commit, state }: { commit: Commit; state: ActiveSessionsState }) {
    if (!state.connection) return
    state.connection.unsubscribe()
    commit("setConnection", null)
  },

  async loadActiveSessions({ commit }: { commit: Commit }) {
    commit("setLoading", true)
    try {
      const response = await client.query({
        query: ACTIVE_SESSIONS_QUERY,
      })
      commit("replaceSessions", response.data.activeSessions.testSessions)
    } catch (_) {
      emitAlert(EVENTS.GLOBAL_ERROR, "Failed loading active sessions")
    }
    commit("setLoading", false)
  },
}
